module.exports = __webpack_public_path__ + "img/Slice11-min.8c393715.png";